<script>
export default {
  name: "AsyncForm",
  props: {
    form: {},
    submit: {
      type: Function,
      required: true
    }
  },
  data() {
    return {
      isLoading: false,
      hasError: false,
      errorMessage: "",
      formState: {
        isLoading: false
      }
    };
  },
  provide() {
    return {
      formState: this.formState
    };
  },
  methods: {
    async onSubmit(e) {
      e.preventDefault();
      this.isLoading = true;
      this.formState.isLoading = true;
      try {
        await this.submit(this.form);
      } catch (error) {
        this.hasError = true;
        if (error.response && error.response.data && error.response.data.title) {
          this.errorMessage = error.response.data.title;
        } else {
          this.errorMessage = error.message;
        }
        window.scrollTo(0, 0);
      } finally {
        this.isLoading = false;
        this.formState.isLoading = false;
      }
    }
  },
  render(createElement) {
    return createElement("form", {
      on: {
        submit: this.onSubmit
      }
    }, this.$scopedSlots.default({
      isLoading: this.isLoading,
      hasError: this.hasError,
      errorMessage: this.errorMessage
    }));
  }
};
</script>
